import { render, staticRenderFns } from "./dealMarket.vue?vue&type=template&id=6bd9f391&scoped=true&"
import script from "./dealMarket.vue?vue&type=script&lang=js&"
export * from "./dealMarket.vue?vue&type=script&lang=js&"
import style0 from "./dealMarket.vue?vue&type=style&index=0&id=6bd9f391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9f391",
  null
  
)

export default component.exports